const PrivacyPolicy = () => {
  return (
    <div className="content_sec full">
      <div className="terms_inner">
        <img
          src="assets/images/shoshke_logo.svg"
          loading="lazy"
          alt=""
          className="inner_logo"
        />
        <h1 className="terms_top_title">שושק&#x27;ה – מדיניות פרטיות</h1>
        <div className="terms_date_txt"> (  עודכן לאחרונה ב 22.6.2026  )</div>
        <ul role="list" className="terms_list w-list-unstyled">
          <li className="terms_item">
            <h4 className="terms_title">1. מטרת מדיניות פרטיות זו:</h4>
            <p className="terms_par">
              1.1. עקב שימושך באתר, ייתכן ויימסר וייאסף מידע אישי לגביך. איסוף
              המידע יכול להיות לאחר מסירתו על ידך, על ידי צדדים שלישיים או
              איסופו באמצעים אוטומטיים
            </p>
            <p className="terms_par">
              1.2. מדיניות פרטיות זו (להלן: "<strong>מדיניות הפרטיות</strong>"),
              מסדירה את היחסים בין חברת מוטק&#x27;ה ושושק&#x27;ה ניהול אתרים
              בע"מ, ח.פ. 516991213 (להלן: "<strong>החברה</strong>") לבינך, בכל
              האמור לנושאים הנדונים במדיניות הפרטיות, ובפרט לגבי המידע האישי
              שייאסף (להלן: "<strong>המידע האישי</strong>")
            </p>
          </li>
          <li className="terms_item">
            <h4 className="terms_title">2. כללי:</h4>
            <div className="terms_par">
              <div className="terms_inline_txt">
                2.1. מדיניות פרטיות זו חלה על השימוש באתר האינטרנט מוטק&#x27;ה
                הזמין בכתובת האינטרנט
              </div>
              <a
                href="https://www.motke.co.il"
                target="_blank"
                className="terms_link"
              >
                www.motke.co.il
              </a>
              <div className="terms_inline_txt">
                {" "}
                (להלן: "<strong>האתר</strong>").
              </div>
            </div>
            <div className="terms_par">
              <div className="terms_inline_txt">
                2.2. האתר מופעל על ידי החברה. ניתן ליצור קשר עם החברה בדרכים
                הבאות: במייל{" "}
              </div>
              <a
                href="mailto:info@motke.co.il?subject=%D7%A9%D7%95%D7%A9%D7%A7&#x27;%D7%94%20%E2%80%93%20%D7%9E%D7%93%D7%99%D7%A0%D7%99%D7%95%D7%AA%20%D7%A4%D7%A8%D7%98%D7%99%D7%95%D7%AA"
                className="terms_link"
              >
                info@motke.co.il
              </a>
              <div className="terms_inline_txt">
                {" "}
                או בווטסאפ למספר: 053-3769023 או בטלפון למספר: 073-2724104 או
                בכתובת מרידור
              </div>
            </div>
            <p className="terms_par">
              2.3. מדיניות הפרטיות מהווה חלק בלתי נפרד מתנאי השימוש באתר (להלן:
              "תנאי השימוש") והמושגים המוגדרים בתנאי השימוש ישמשו גם במדיניות
              פרטיות זו
            </p>
            <p className="terms_par">
              2.4. הכתוב מנוסח בלשון זכר אך נכון גם ללשון נקבה. הכתוב בלשון יחיד
              נכון גם ללשון רבים
            </p>
            <p className="terms_par">
              2.5. הכותרות לאורך תנאי השימוש ומדיניות הפרטיות מובאות לשם נוחות
              בלבד והן אינן משמשות הסבר או מהוות פרשנות לסעיפים המרכיבים את
              מדיניות הפרטיות
            </p>
          </li>
          <li className="terms_item">
            <h4 className="terms_title">3. אין חובה למסירת מידע אישי:</h4>
            <p className="terms_par">
              3.1. למען הסר ספק, מובהר כי אין עליך כל חובה חוקית למסור את המידע
              האישי ו/או לאפשר לצדדים שלישיים למסור מידע אישי לגביך, במסגרת
              הרישום לשימוש באתר ו/או במסגרת השימוש באתר
            </p>
            <p className="terms_par">
              3.2. עם זאת, אם לא תסכים למסירת המידע האישי הנדרש לרישום, לא ניתן
              יהיה לעשות שימוש באתר ולא ניתן יהיה לקבל שירותים כלשהם ממנו
            </p>
          </li>
          <li className="terms_item">
            <div className="terms_title">
              <div className="terms_inline_txt">4. המידע האישי שייאסף:</div>
              <div className="terms_inline_txt no_bold">
                כאמור, המידע האישי כולל כל מידע אשר יתקבל אודותיך, ובין היתר,
                עשוי לכלול את סוגי המידע הבאים:
              </div>
            </div>
            <p className="terms_par">
              4.1. פרטי התקשרות ופרטים אישיים כגון שם, כתובת מגורים, כתובת דוא"ל
              ומספרי טלפון
            </p>
            <p className="terms_par">
              4.2. נתונים אישיים כגון מין, תאריך לידה, מצב אישי, מצב משפחתי
            </p>
            <p className="terms_par">4.3. נתונים סוציואקונומיים כגון השכלה</p>
            <p className="terms_par">
              4.4. נתונים לגבי הרגלים והעדפות אישיים כגון תדירות וסוג חופשות
              ובילויים בשעות הפנאי, נסיעות לחו"ל
            </p>
            <p className="terms_par">
              4.5. מידע פיננסי ופרטי חשבון כגון מספר חשבון בנק, נתוני כרטיס
              אשראי
            </p>
            <p className="terms_par">4.6. נתונים פיזיים ובכלל זה גובה</p>
            <p className="terms_par">
              4.7. מספרי זיהוי כגון תעודת זהות, דרכון ורישיון נהיגה
            </p>
            <p className="terms_par">
              4.8. היסטוריית גלישה ונתוני צפייה בפרסומות;
            </p>
            <p className="terms_par">4.9. מידע ביומטרי כגון תמונות</p>
            <p className="terms_par">
              4.10. מידע השמור בקבצי קול, כגון קבצי שמע המועלים לאתר;
            </p>
            <p className="terms_par">4.11. מידע לגבי מיקומך</p>
            <p className="terms_par">4.12. כל מידע רגיש אחר</p>
          </li>
          <li className="terms_item">
            <h4 className="terms_title">
              5. השימוש במידע – מטרות השימוש במידע האישי הן:
            </h4>
            <p className="terms_par">5.1. זיהוי שלך באופן מקוון או אחר</p>
            <p className="terms_par">
              5.2. מעקב על מיקומך בהתאם לנתונים המתקבלים מההתקנים בהם אתה עושה
              שימוש, נייחים או ניידים
            </p>

            <p className="terms_par">
              5.3. שליחת דבר פרסומת לפי כאמור בסע' 30א לחוק התקשורת (בזק
              ושידורים), התשמ"ב – 1982 (אשר מכונה "<strong>חוק הספאם</strong>")
            </p>

            <p className="terms_par">
              5.4. קביעת תנאי תשלום, גביית תשלומים ולצרכים החשבונאיים של החברה
            </p>
            <p className="terms_par">
              5.5. להתאים את חוויית המשתמש שלך להעדפותיך האישיות, וזאת על פי
              שיקול דעתה הבלעדי של החברה
            </p>
            <p className="terms_par">
              5.6. במסגרת הליכים משפטיים, בין אם החברה צד להם ובין אם לאו,
              ובהתאם לכל דרישה חוקית
            </p>
            <p className="terms_par">
              5.7. תיקון ו/או טיוב ו/או עיבוד המידע על מנת להפיק תובנות
              סטטיסטיות ואחרות
            </p>
          </li>
          <li className="terms_item">
            <h4 className="terms_title">6. העברת מידע לצדדים שלישיים</h4>
            <p className="terms_par">
              6.1. במסגרת רכישת מוצרים ושירותים באמצעות האתר, ייתכן והמידע האישי
              שלך יועבר אל הגורמים המספקים את המוצרים או השירותים (להלן: "
              <strong>הספקים החיצוניים</strong>")
            </p>
            <p className="terms_par">
              6.2. החברה לא תהיה אחראית לכל שימוש לרעה במידע האישי על ידי הספקים
              החיצוניים
            </p>
            <p className="terms_par">
              6.3. חלה עליך האחריות לבדוק את תנאי השימוש של הספקים החיצוניים על
              מנת להבין מה כולל השימוש שלהם במידע האישי שלך
            </p>
          </li>
          <li className="terms_item">
            <h4 className="terms_title">
              7. רישיון מאגר מידע ומחזיקי המידע האישי
            </h4>
            <p className="terms_par">
              7.1. המידע שמגיע לידי החברה באמצעות האתר ו/או אשר נוצר תוך כדי
              שימוש באתר, ובכלל זה המידע האישי (ביחד להלן: "
              <strong>המידע באתר</strong>"), נאסף ונשמר בחוות שרתים ("
              <strong>ענן</strong>") של חברת אקספים, בכתובת מעבר יבוק 5, תל
              אביב, טל&#x27; 03-6005252, במאגר מידע הפועל לפי רישיון הרשות להגנת
              הפרטיות במשרד המשפטים שמספרו 1068272 (להלן "<strong>המאגר</strong>
              ").
            </p>
          </li>
          <li className="terms_item">
            <h4 className="terms_title">8. שימוש בקבצי Cookies:</h4>
            <p className="terms_par">
              Cookies ("<strong>עוגיות</strong>"), אשר אוספים סוגי מידע שונים
              עליך כגון היסטוריית גלישה, משך שהייה באפליקציה או העדפות. השימוש
              במידע זה נועד לשפר את השימוש באתר בדרכים שונות כגון התאמה אישית
              אליך וייעול הצגת המידע עבורך. מובהר כי השימוש בקבצי Cookies עלול
              להיות מבלי לבקש את אישורך, אולם אתה רשאי בכל זמן שהוא לנקות את
              קבצי ה- Cookies או לשנות את הגדרות השימוש באופן שימנע את השימוש
              בהם על ידי האתר
            </p>
          </li>
          <li className="terms_item">
            <h4 className="terms_title">9. שמירת המידע:</h4>
            <p className="terms_par">
              9.1. המידע האישי יישמר ברשות החברה לפרק זמן בלתי מוגבל
            </p>
            <p className="terms_par">
              9.2. אתה תוכל להסיר את חשבונך באתר וכל פריט מידע מתוך המידע האישי
              שלך, אם תבקש זאת בכתב מהחברה, ובהתאם להוראות הדין
            </p>
          </li>
          <li className="terms_item">
            <h4 className="terms_title">
              <strong>10. עיון במידע ושינויו:</strong>
            </h4>
            <p className="terms_par">
              אתה רשאי לעיין בעצמך, באמצעות בא כוחך שקיבל הרשאה בכתב, או באמצעות
              אפוטרופוס במידע האישי שלך. כמו כן, אתה רשאי לבקש את תיקון המידע
              האישי אם לדעתך מדובר במידע שאינו נכון, שלם, ברור או מעודכן. האופן,
              התנאי והתשלום למימוש זכות העיון וכן תיקון מידע קבועים בתקנות הגנת
              הפרטיות (תנאים לעיון במידע וסדרי הדין בערעור על סירוב לבקשת עיון),
              תשמ"א-1981. למען הסר ספק מובהר עם זאת כי מחיקת מידע לגביך עלולה
              לפגוע ביעילות השימוש באתר ו/או בכל שירות הניתן לך, בין באופן ישיר
              ובין באמצעות משתמשים אחרים.
            </p>
          </li>
          <li className="terms_item">
            <h4 className="terms_title">11. צדדים שלישיים:</h4>
            <p className="terms_par">
              11.1. למען הסר ספק מובהר כי מדיניות הפרטיות מתייחסת לאתר בלבד.
              מדיניות הפרטיות לא חלה על אתרים של צדדים שלישיים שעשויים להיות
              אליהם קישורים מהאתר וכן לא חלה על הספקים החיצוניים
            </p>
            <p className="terms_par">
              11.2. באחריותך לברר את תנאי מדיניות הפרטיות של הספקים החיצוניים
              ושל אתרים של צד שלישי בהם נעשה שימוש על ידך
            </p>
          </li>
          <li className="terms_item">
            <h4 className="terms_title">12. פגיעה בזכויות לפרטיות:</h4>
            <p className="terms_par">
              במקרה של פריצת מידע כתוצאה מפעולה מכוונת מצד גורם עויין או כתוצאה
              מטעות שלך או מכל סיבה אחרת שאיננה נתונה לשליטת החברה, החברה לא
              תהיה אחראית לשום נזק מכל סוג שהוא, שעלול להיגרם כתוצאה מפריצת מידע
              זו.
            </p>
          </li>
          <li className="terms_item">
            <h4 className="terms_title">13. שינויים במדיניות הפרטיות:</h4>
            <p className="terms_par">
              החברה שומרת על זכותה לעדכן מדיניות פרטיות זו על פי שיקול דעתה
              הבלעדי ואתה נדרש להתעדכן מפעם לפעם בתנאי מדיניות הפרטיות.
            </p>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
